import React from "react";
import { useAuth } from "./authProvider";
import "./login.css";
import logo2 from "../assets/logo2.png";
import microsoftlogo from "../assets/microsoftlogo.png";
import googlelogo from "../assets/googlelogo.png";

const LoginButton = () => {
  const { user, loading, loginWithGoogle, loginWithMicrosoft, logout, authError } = useAuth();

  if (loading) {
    return (
      <div className="login-container">
      <div className="communitylogin">
      <img src={logo2} alt="Logo" className="logo" />
      <h2 className="login-message">Community Sverige AB</h2></div>
      <h2 className="login-message1">Enhetsportalen</h2>
      <h4 className="login-load">Loggar in....</h4>
      <div className="spinner" />
      </div>
    );
  }
  
  return (
    <div className="login-container">
      <div className="communitylogin">
      <img src={logo2} alt="Logo" className="logo" />
      <h2 className="login-message">Community Sverige AB</h2></div>
      <h2 className="login-message1">Enhetsportalen</h2>
      <h4 className="login-message2">Logga in med ditt Microsoft eller Google konto</h4>
      <hr />

      {authError && <p className="error-message">{authError}</p>}

{user ? (
  <div>
    <p>Inloggad som {user.email}</p>
    <p>Företag: {user.company}</p>
    {user.isAdmin && <p>🛠 Admin-rättigheter</p>}
    <button onClick={logout} className="logoutbutton">Logga ut</button>
  </div>
) : (
  <>
    <div className="MSloginbox">
      <button onClick={loginWithMicrosoft} className="loginbuttonMS">
        
        <img src={microsoftlogo} alt="Microsoft Logo" className="button-logo" />
        Logga in med Microsoft
      </button>
    </div>
    
    <div className="Googleloginbox">
      <button onClick={loginWithGoogle} className="loginbuttonGoogle">
        <img src={googlelogo} alt="Google Logo" className="button-logo" />
        Logga in med Google
      </button>
    </div>
  </>
)}
</div>
);
};

export default LoginButton;